import { apiRoutes } from 'config/apiRoutes'
import axios from 'libs/fetch'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseMarkAsTakeDownNotifiedProps = {
	id: number | undefined
	closeModal: () => void
}

export const useMarkAsTakeDownNotified = ({ id, closeModal }: UseMarkAsTakeDownNotifiedProps) => {
	const queryClient = useQueryClient()
	const { t } = useTranslation()

	const { mutate: markAsTakeDownNotified } = useMutation({
		mutationFn: (id: number) => axios.post(apiRoutes.bookingMarkAsTakeDownNotified(id.toString())),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Booking marked as take down notified')
			})()

			if (id) {
				queryClient.invalidateQueries({ queryKey: queryKeys.bookings.detail(id.toString()) })
			}
			closeModal()
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.detail ?? t('Something went wrong')
			})()
		}
	})

	return {
		markAsTakeDownNotified
	}
}
